import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const RadioButtonGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: ${pxToRem(16)};
  row-gap: ${pxToRem(24)};
  ${({ theme: { mediaQueries } }) =>
    mediaQueries.isTablet &&
    css`
      grid-template-columns: repeat(2, 1fr);
    `}
  ${({ theme: { mediaQueries } }) =>
    mediaQueries.isMobile &&
    css`
      grid-template-columns: 1fr;
    `}
`;

export const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(4)};
  margin-top: ${pxToRem(8)};
`;

export const ServiceListItemTitleBar = styled.div`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

export const IconWrapper = styled.div`
  margin-left: auto;
`;

export const RadioButton = styled.input.attrs({ type: 'radio' })`
  appearance: none; /* Remove default styling */
  width: ${pxToRem(22)};
  height: ${pxToRem(22)};
  margin-right: ${pxToRem(8)};
  border: ${pxToRem(2)} solid ${({ theme }) => theme.colors.neutral300};
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:checked {
    border-color: ${({ theme }) => theme.colors.brand1};
    background-color: ${({ theme }) => theme.colors.brand1};
    box-shadow: inset 0 0 0 ${pxToRem(4)} #fff;
  }
  &checked:before {
    background-color: ${({ theme }) => theme.colors.brand1};
    content: '';
    width: 1em;
    height: 1em;
    border-radius: 50%;
    display: block;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.brand1};
  }

  &:focus {
    box-shadow: 0 0 0 ${pxToRem(3)} ${({ theme }) => theme.colors.neutral100};
  }
`;

export const RadioButtonLabel = styled.label`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textbrand1};
  font-size: ${pxToRem(12)};
  cursor: pointer;
  gap: ${pxToRem(4)};

  &:hover ${RadioButton} {
    border-color: ${({ theme }) => theme.colors.brand1};
  }
`;

export const ServiceListItemLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${pxToRem(16)};
  margin-right: ${pxToRem(8)};
`;
